import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

import { downloadOutputDocument } from "@/api/documents";
import { downloadBlob } from "@/utils/download-blob";

export function useOutputDocumentDownload() {
    return useMutation({
        mutationFn: async (documentId: number) => {
            const { blob, filename } = await downloadOutputDocument(documentId);
            downloadBlob(blob, filename);
        },
        onSuccess: () => {
            toast.success("Document downloaded");
        },
        onError: () => {
            toast.error("Couldn't download this document. Please try again.");
        },
    });
}
